import { createStyles } from '@material-ui/core/styles'
import { getCommon } from './common'

const common = getCommon()
export const stylesResult = createStyles({
  hide: {
    ...common.display.none,
  },
  container: {
    ...common.display.flex,
    ...common.custom.flexContainerColumnFull,
    borderRadius: '45px !important',
    width: '300px',
  },
  card: {
    marginTop: common.theme.spacing(2),
  },
  cardAvatar: {
    ...common.background.primary,
    [common.theme.breakpoints.up('sm')]: {
      ...common.display.flex,
    },
    [common.theme.breakpoints.up('md')]: {
      ...common.display.none,
    },
  },
  cardAvatarIcon: {
    ...common.text.color.white,
  },
  cardHeader: {
    ...common.display.flex,
    ...common.custom.flexContainerRowFull,

    '& .MuiCardHeader-title, & .MuiCardHeader-avatar': {
      marginBottom: '15px',
    },

    '& .MuiCardHeader-content': {
      flex: '0 0 auto !important',
    },
    '& span': {
      fontSize: '2.2rem',
    },
  },
  cardIcon: {
    fontSize: '8rem',
    ...common.text.color.primary,
    ...common.display.none,

    [common.theme.breakpoints.up('md')]: {
      ...common.display.flex,
    },
  },
  textWithIcon: {
    ...common.display.flex,
    ...common.custom.flexContainerRowMiddle,
    ...common.flexContainer.row.center,
    ...common.width.full,
    marginBottom: common.theme.spacing(0.5),
    [common.theme.breakpoints.up('md')]: {
      marginBottom: common.theme.spacing(0),
      ...common.flexContainer.row.left,
    },
  },
  dataWithIcon: {
    ...common.display.flex,
    ...common.custom.flexContainerRowMiddle,
    ...common.flexContainer.row.center,
    ...common.width.full,
    marginBottom: common.theme.spacing(0.5),
    [common.theme.breakpoints.up('md')]: {
      marginBottom: common.theme.spacing(0),
    },
  },
  dataIcon: {
    ...common.text.color.primaryShade,
    padding: common.theme.spacing(3),
    fontSize: common.theme.spacing(2.5),
    width: common.theme.spacing(3),
  },
  yesIcon: {
    ...common.text.color.success,
    padding: common.theme.spacing(3),
    fontSize: common.theme.spacing(2.5),
    width: common.theme.spacing(3),
  },
  noIcon: {
    ...common.text.color.danger,
    padding: common.theme.spacing(3),
    fontSize: common.theme.spacing(2.5),
    width: common.theme.spacing(3),
  },
  dataText: {
    fontSize: common.theme.spacing(2.5),
    marginRight: common.theme.spacing(1),
  },
  actionText: {
    marginLeft: common.theme.spacing(2.5),
    ...common.width.auto,
    [common.theme.breakpoints.up('sm')]: {
      ...common.width.full,
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: common.theme.transitions.create('transform', {
      duration: common.theme.transitions.duration.shortest,
    }),
    '& :hover': {
      background: ' #ff6f76 !important;',
    },
    background: common.colors.primary(),
    color: common.colors.white() + '!important',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  moreIcon: {
    '& :hover': {
      background: ' #ff6f76 !important;',
    },
  },
})
